import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useOnboarding } from '../contexts/OnboardingContext';
import { OnboardingModals } from './onboarding/OnboardingModals';
import { Navigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

export const OnboardingModal: React.FC = () => {
  const { t } = useLanguage();
  const { currentUser, loading: authLoading } = useAuth();
  const { isOnboardingComplete, loading: onboardingLoading } = useOnboarding();

  // Show initial loading state only if auth is still loading (first mount)
  if (authLoading && !currentUser) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (isOnboardingComplete) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      {/* Show loading overlay on top of modals during async operations */}
      {onboardingLoading && (
        <div className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-[60]">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">{t('common.loading')}</p>
          </div>
        </div>
      )}
      <OnboardingModals />
    </>
  );
}; 